import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";
import { getLocalStorage } from "@/helpers/common";
import { USER_INFO_KEY } from "@/constants/common";
import useAgentGitchaRestrictions from "./useAgentGitchaRestrictions";
import { hasBlsHost, openInBls } from "@/helpers/crossLoginHelper";

export const useMLSAgentAtGitchaHomeRedirect = () => {
    const navigate = useNavigate();
    const { shouldRestrictAgent } = useAgentGitchaRestrictions();

    useEffect(() => {
        if (shouldRestrictAgent) {
            navigate(pageURLs.home);
        }
    }, [shouldRestrictAgent]);

    return null;
}

export const useMLSAgentAtGitchaRedirect = () => {

    const { shouldRestrictAgent } = useAgentGitchaRestrictions();

    const sessionData = getLocalStorage(USER_INFO_KEY);
    const mls = sessionData?.userInfo?.mls;

    const redirectToBLSEnv = (props) => {

        if (shouldRestrictAgent && props?.path && hasBlsHost(mls)) {
            openInBls(mls, props.path);
            return
        }

        props?.onGitchaEnvFallback?.();
    }

    return { redirectToBLSEnv, shouldRestrictAgent };

}
